import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import 'moment/locale/vi';
import './styles/app.scss';
import { IntlProvider } from 'react-intl';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5,
        },
    },
});
ReactDOM.render(
    <Provider store={store}>
        <IntlProvider locale="en">
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </IntlProvider>
    </Provider>,
    document.getElementById('admin_core'),
);

const bundleLoadedEvent = new Event('bundle-loaded');
const splashScreen = document.getElementById('splash-screen');
splashScreen.dispatchEvent(bundleLoadedEvent);
